import { SUPPORTED_MODE } from "../../../types/navigation-mode";
import { useState } from "react";
import ImageButton from "../../button/image-button";
import Image from "../../image";
import Text from "../../text/text";
import { useFindPath } from "../../../hooks/useFindPath";
import { useNavigationStore } from "../../../store/navigationStore";
import useMdBreakpoint from "@/hooks/useMdBreakpoint";
// import useMessagePlayer from "@/hooks/useMessagePlayer";

// interface NavModeSelectorProps {
//   currentMode: string;
//   setCurrentMode: (code: string) => void
// }

export default function NavModeSelector() {
  const [isModeOpen, setIsModeOpen] = useState(false);
  const { handleUserQuery } = useFindPath();
  const getIconPath = (code: string) => `assets/icon_${code}.png`;
  const userQuery = useNavigationStore((state) => state.userQuery);
  const currentMode = useNavigationStore((state) => state.currentMode);
  const setCurrentMode = useNavigationStore((state) => state.setCurrentMode);
  const setInterrupt = useNavigationStore((state) => state.setInterrupt);
  const stopAutoPlay = useNavigationStore((state) => state.stopAutoPlay);
  const isMd = useMdBreakpoint();
  // const { cancelReading } = useMessagePlayer();
  const useCurrentLocation = useNavigationStore(
    (state) => state.useCurrentLocation
  );

  const changeNavigation = async (newMode: string) => {
    // cancelReading();
    stopAutoPlay();
    setInterrupt(true);
    await handleUserQuery(userQuery, {
      mode: newMode,
      useCurrentLocation: useCurrentLocation,
    });
  };

  return (
    <div
      aria-expanded={isModeOpen}
      onClick={() => setIsModeOpen((v) => !v)}
      className={`flex items-center rounded-full btn-style backdrop-blur transition-all duration-300 overflow-hidden 
      ${isModeOpen && !isMd ? "absolute" : "relative"}
      ${isModeOpen ? "actived" : ""} 
  `}
    >
      {/* Trigger shows current mode icon when collapsed */}
      {!isModeOpen ? (
        <span className="flex items-center justify-center w-[110px] h-[40px] shrink-0">
          <Image
            className="mr-[8px]"
            aria-hidden
            src={getIconPath(currentMode)}
            alt="selected mode icon"
            width={22}
            height={22}
          />{" "}
          <Text text="mode" className="text-500" />
        </span>
      ) : (
        <span
          className={`flex items-center px-2 h-[40px] transition-all duration-300 ${
            isModeOpen
              ? "opacity-100 translate-x-0"
              : "opacity-0 -translate-x-2"
          } overflow-hidden`}
        >
          <ImageButton
            onClick={(e) => {
              e.stopPropagation();
              setIsModeOpen(false);
            }}
            className="flex items-center justify-center w-9 h-9 rounded-full hover:bg-white/10 transition-colors"
            src="/assets/icon_close.png"
            alt="close"
            size={18}
          />

          <span className="mx-1 h-5 w-px bg-white/20" />
          {SUPPORTED_MODE.map((m, idx) => (
            <div key={m.code} className="flex items-center">
              {idx > 0 && <span className="mx-1 h-5 w-px bg-white/20" />}
              <ImageButton
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentMode(m.code);
                  setIsModeOpen(false);
                  changeNavigation(m.code);
                }}
                className="flex items-center justify-center w-9 h-9 rounded-full hover:bg-white/10 transition-colors"
                src={getIconPath(m.code)}
                alt={`${m.name} icon`}
                size={20}
              />
            </div>
          ))}
        </span>
      )}
    </div>
  );
}
